<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_vi"></a>CONTENTS</h2>
<p class="toca"><a href="#/xhtml/preface#pre"><em>Author’s Preface</em></a></p>
<p class="toca"><a href="#/xhtml/introduction#int"><em>Editors’ Introduction</em></a></p>
<p class="toca"><a href="#/xhtml/abbreviation#abb"><em>List of Abbreviations</em></a></p>
<p class="toct"><a href="#/xhtml/chapter01#ch1">1 Early Roots of the Heifetz Family</a></p>
<p class="toc"><a href="#/xhtml/chapter02#ch2">2 1901–1906: Vilnius</a></p>
<p class="toc"><a href="#/xhtml/chapter03#ch3">3 1906–1909: Music School</a></p>
<p class="toc"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">4 1910: St. Petersburg Conservatory and Nalbandian</span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">5 First Performances in St. Petersburg</span></p>
<p class="toc"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample">6 Summer 1911: Concerts in Pavlovsk and Odessa</span></p>
<p class="toc"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample">7 Fall 1911: In the Class of Professor Auer</span></p>
<p class="toc"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample">8 The Beginning of 1912</span></p>
<p class="toc"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample">9 1912: First Trip to Germany</span></p>
<p class="toc1"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10 1912: A German Tour</span></p>
<p class="toc1"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11 The Beginning of 1913</span></p>
<p class="toc1"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12 Summer–Fall 1913: Loschwitz</span></p>
<p class="toc1"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13 Winter 1913–1914: Bar Mitzvah</span></p>
<p class="toc1"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14 Spring 1914</span></p>
<p class="toc1"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15 Summer–Fall 1914: War</span></p>
<p class="toc1"><a id="page_vii"></a><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">l6 January–September 1915</span></p>
<p class="toc1"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17 The End of 1915</span></p>
<p class="toc1"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">18 The First Half of 1916</span></p>
<p class="toc1"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">19 The Second Half of 1916: Norway and Denmark</span></p>
<p class="toc1"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">20 The First Half of 1917: February Revolution</span></p>
<p class="toc1"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">21 Summer 1917: Departure for America</span></p>
<p class="tocat"><span href="#/xhtml/appendix1#app1" title="Link target outside of Sample"><em>Appendix 1: Reviews of Jascha Heifetz’s Debut at Carnegie Hall, October 27,1917</em></span></p>
<p class="toca"><span href="#/xhtml/appendix2#app2" title="Link target outside of Sample"><em>Appendix 2: Jascha Heifetz’s Repertoire in Russia</em></span></p>
<p class="toca"><span href="#/xhtml/notes#not" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toca"><span href="#/xhtml/source#src" title="Link target outside of Sample"><em>Selected Sources</em></span></p>
<p class="toca"><span href="#/xhtml/index#ind" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2c4b3c3e